import React, { useState } from "react";
import "./ModelCard.css";

const ModelCard = ({ model }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);

  // Verifica se há múltiplas imagens ou apenas uma
  const images =
    Array.isArray(model.images) && model.images.length > 0
      ? model.images
      : model.image
        ? [model.image]
        : [];

  const handleDownload = () => {
    // Cria um link temporário para download
    const link = document.createElement("a");
    link.href = model.file;
    link.download = model.file.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePrevImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNextImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const getConfigIcon = (type) => {
    const icons = {
      nozzle: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M7 2h10v5h2v6h-2.5L13 17h-2l-3.5-4H5V7h2zm3 20H2v-2h8a1 1 0 0 0 1-1v-1h2v1a3 3 0 0 1-3 3M7 9v2h1.5l3.5 4l3.5-4H17V9h-2V4H9v5z"
          />
        </svg>
      ),
      layer: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <rect x="3" y="6" width="18" height="2" />
          <rect x="3" y="11" width="18" height="2" />
          <rect x="3" y="16" width="18" height="2" />
        </svg>
      ),
      walls: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <rect x="4" y="4" width="16" height="16" rx="2" />
          <rect x="8" y="8" width="8" height="8" rx="1" />
        </svg>
      ),
      infill: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M4 4h16v16H4z" />
          <path d="M4 4l16 16M20 4L4 20" />
        </svg>
      ),
      filament: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M22 12c0-5.51-4.49-10-10-10S2 6.49 2 12s4.49 10 10 10h10v-2h-4.03c2.44-1.83 4.03-4.73 4.03-8M4 12c0-4.41 3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8s-8-3.59-8-8"
          />
          <path
            fill="currentColor"
            d="M12 6a2 2 0 1 0 0 4a2 2 0 1 0 0-4m0 8a2 2 0 1 0 0 4a2 2 0 1 0 0-4m4-4a2 2 0 1 0 0 4a2 2 0 1 0 0-4m-8 0a2 2 0 1 0 0 4a2 2 0 1 0 0-4"
          />
        </svg>
      ),
      support: (
        <svg
          width="240"
          height="240"
          viewBox="0 0 240 240"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="30" y="190" width="180" height="20" rx="6" ry="6" />
          <rect x="50" y="50" width="140" height="24" rx="6" ry="6" />
          <rect x="152" y="74" width="36" height="110" rx="6" ry="6" />
          <line x1="70" y1="74" x2="70" y2="190" />
          <line x1="120" y1="74" x2="120" y2="190" />
          <line x1="70" y1="100" x2="120" y2="80" />
          <line x1="70" y1="105" x2="120" y2="130" />
          <line x1="120" y1="130" x2="70" y2="150" />
          <line x1="120" y1="170" x2="70" y2="150" />
          <line x1="120" y1="170" x2="70" y2="190" />
        </svg>
      ),
    };
    return icons[type] || null;
  };

  return (
    <div className="model-card">
      <div className="card-image-wrapper">
        {images.length > 0 ? (
          <>
            <img
              src={images[currentImageIndex]}
              alt={`${model.title} - ${currentImageIndex + 1}`}
              className="card-image"
              onError={(e) => {
                e.target.src =
                  'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300"%3E%3Crect fill="%23f3f4f6" width="400" height="300"/%3E%3Ctext fill="%239ca3af" font-family="sans-serif" font-size="18" dy="10.5" font-weight="bold" x="50%25" y="50%25" text-anchor="middle"%3EImagem não disponível%3C/text%3E%3C/svg%3E';
              }}
            />
            {images.length > 1 && (
              <>
                <button
                  className="carousel-button prev"
                  onClick={handlePrevImage}
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                  >
                    <path d="M15 18l-6-6 6-6" />
                  </svg>
                </button>
                <button
                  className="carousel-button next"
                  onClick={handleNextImage}
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </button>
                <div className="carousel-indicators">
                  {images.map((_, index) => (
                    <span
                      key={index}
                      className={`indicator ${index === currentImageIndex ? "active" : ""}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setCurrentImageIndex(index);
                      }}
                    />
                  ))}
                </div>
              </>
            )}
          </>
        ) : (
          <div className="no-image">Sem imagem</div>
        )}
      </div>

      <div className="card-content">
        <h3 className="card-title">{model.title}</h3>
        <p className="card-description">{model.description}</p>

        <button
          className={`details-button ${isExpanded ? "expanded" : ""}`}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <span>Detalhes</span>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M6 9l6 6 6-6" />
          </svg>
        </button>
      </div>

      {isExpanded && (
        <div className="expanded-content">
          {model.configs && (
            <div className="config-section">
              <h4 className="config-title">Configurações de Impressão</h4>
              <div className="config-grid">
                {model.configs.bico && (
                  <div
                    className="config-item"
                    title="Tamanho do bico da impressora"
                  >
                    {getConfigIcon("nozzle")}
                    <div className="config-info">
                      <span className="config-label">Bico</span>
                      <span className="config-value">{model.configs.bico}</span>
                    </div>
                  </div>
                )}
                {model.configs.alturaCamada && (
                  <div
                    className="config-item"
                    title="Altura de cada camada de impressão"
                  >
                    {getConfigIcon("layer")}
                    <div className="config-info">
                      <span className="config-label">Camada</span>
                      <span className="config-value">
                        {model.configs.alturaCamada}
                      </span>
                    </div>
                  </div>
                )}
                {model.configs.paredes && (
                  <div
                    className="config-item"
                    title="Número de paredes/perímetros"
                  >
                    {getConfigIcon("walls")}
                    <div className="config-info">
                      <span className="config-label">Paredes</span>
                      <span className="config-value">
                        {model.configs.paredes}
                      </span>
                    </div>
                  </div>
                )}
                {model.configs.preenchimento && (
                  <div
                    className="config-item"
                    title="Percentual de preenchimento interno"
                  >
                    {getConfigIcon("infill")}
                    <div className="config-info">
                      <span className="config-label">Preenchimento</span>
                      <span className="config-value">
                        {model.configs.preenchimento}
                      </span>
                    </div>
                  </div>
                )}
                {model.configs.filamento && (
                  <div
                    className="config-item"
                    title="Tipo de filamento recomendado"
                  >
                    {getConfigIcon("filament")}
                    <div className="config-info">
                      <span className="config-label">Filamento</span>
                      <span className="config-value">
                        {model.configs.filamento}
                      </span>
                    </div>
                  </div>
                )}
                {model.configs.suporte && (
                  <div
                    className="config-item"
                    title="Necessidade de estruturas de suporte"
                  >
                    {getConfigIcon("support")}
                    <div className="config-info">
                      <span className="config-label">Suporte</span>
                      <span className="config-value">
                        {model.configs.suporte}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {model.observacoes && (
            <div className="observations-section">
              <h4 className="observations-title">Observações</h4>
              <p>{model.observacoes}</p>
            </div>
          )}

          <button className="card-button" onClick={handleDownload}>
            <svg
              className="button-icon"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
            Download
          </button>
        </div>
      )}
    </div>
  );
};

export default ModelCard;
